import { GET_NOTIFICATIONS_ASYNC, UPDATE_NOTIFICATIONS_ASYNC } from './constants'

const getNotifications = () => ({ type: GET_NOTIFICATIONS_ASYNC.INITIATE })
const getNotificationsCancel = () => ({ type: GET_NOTIFICATIONS_ASYNC.CANCEL })
export const getNotificationsSuccess = (data) => ({
  type: GET_NOTIFICATIONS_ASYNC.SUCCESS,
  payload: { data },
})
export const getNotificationsError = (error) => ({
  type: GET_NOTIFICATIONS_ASYNC.ERROR,
  error,
})

const updateNotifications = (notifications, coPilot) => ({
  type: UPDATE_NOTIFICATIONS_ASYNC.INITIATE,
  payload: { ...notifications, themis_co_pilot: coPilot },
})
const updateNotificationsCancel = () => ({
  type: UPDATE_NOTIFICATIONS_ASYNC.CANCEL,
})
export const updateNotificationsSuccess = () => ({
  type: UPDATE_NOTIFICATIONS_ASYNC.SUCCESS,
})
export const updateNotificationsError = (error) => ({
  type: UPDATE_NOTIFICATIONS_ASYNC.ERROR,
  error,
})

export default {
  // to props
  getNotifications,
  getNotificationsCancel,
  updateNotifications,
  updateNotificationsCancel,
}
